import React from 'react';
import {GameLink} from './GameLink';

const Games = (props) => {
	const { games } = props;
	if (games) {
		return (
			<ul className="list-group">
					{games.map(function (item, i) {
					return <GameLink name={item.name}
						description={item.description}
						id={item.id}
						key={i} />;
				}
				)}
			</ul>
		)
	}
	else {
		return (
			<div className="alert alert-info">...checking for games.</div>
		)
	}
}

export default Games;